import { Theme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'

import theme from '@styles/theme/theme'

// Extend the Theme interface to include custom palette properties
declare module '@mui/material/styles' {
  interface Palette {
    elements: {
      white: string
      main: string
      light: string
    }
  }
}

// Ensure theme.palette.text.light exists in our type system
const textLight = theme.palette.text?.light || '#ccc'
const elementsLight = theme.palette.elements?.light || '#f5f5f5'
const elementsMain = theme.palette.elements?.main || '#e0e0e0'

const useStyles = makeStyles(() => ({
  root: { width: '100%' },
  dropZone: {
    outline: 'none',
    display: 'flex',
    overflow: 'hidden',
    textAlign: 'center',
    position: 'relative',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create('padding'),
    backgroundColor: elementsLight,
    border: `3px dashed ${elementsMain}`,
    '&:hover': {
      opacity: 0.72,
      cursor: 'pointer',
      border: `3px dashed ${textLight}`
    },
    '& input + img': {
      height: 'auto'
    },
    '& img[alt*=preview]': {
      width: '100%',
      height: 'auto',
      top: 0
    },
    '& > div': {
      marginLeft: 0,
      padding: '0 10px'
    },
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
      flexDirection: 'row'
    }
  },
  hasFile: {
    padding: '0'
  },
  isDragActive: {
    opacity: 0.72,
    border: `3px dashed ${theme.palette.secondary.main}`
  },
  isDragReject: {
    color: theme.palette.error.main,
    borderColor: theme.palette.error.light,
    backgroundColor: theme.palette.error.light
  },
  isDragAccept: {} // Adding this empty entry for TypeScript compatibility
}))

export default useStyles
